(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const announcement = document.querySelector('[data-hz-announcement]');
  const announcementPause = announcement?.querySelector('[data-hz-announcement-pause]');
  if (announcementPause && !reduceMotion) {
    announcementPause.hidden = false;
    announcementPause.addEventListener('click', () => {
      const paused = announcement.classList.toggle('is-paused');
      announcementPause.setAttribute('aria-pressed', String(paused));
      announcementPause.setAttribute('aria-label', paused ? 'Play announcements' : 'Pause announcements');
    });
  }

  const headerMenus = document.querySelectorAll('[data-hz-header-menu]');
  if (headerMenus.length) {
    const desktopHover = window.matchMedia('(min-width: 761px) and (hover: hover) and (pointer: fine)');
    const mobileMenu = window.matchMedia('(max-width: 760px)');
    const syncMobileProductMenu = () => {
      const productMenuOpen = mobileMenu.matches && Array.from(headerMenus).some((menu) =>
        menu.open && menu.querySelector('.hz-new-arrivals-panel')
      );
      document.documentElement.classList.toggle('hz-mobile-product-menu-open', productMenuOpen);
      if (productMenuOpen) {
        const headerBottom = document.querySelector('.m27-store-header').getBoundingClientRect().bottom;
        document.documentElement.style.setProperty('--hz-mobile-menu-top', `${Math.max(0, headerBottom)}px`);
      }
    };
    const hoverCloseTimers = new Map();
    const cancelHoverClose = (menu) => window.clearTimeout(hoverCloseTimers.get(menu));
    const closeMenu = (menu) => {
      cancelHoverClose(menu);
      menu.open = false;
    };
    const openMenu = (menu) => {
      headerMenus.forEach((otherMenu) => {
        if (otherMenu !== menu) closeMenu(otherMenu);
      });
      cancelHoverClose(menu);
      menu.open = true;
    };

    headerMenus.forEach((menu) => {
      menu.addEventListener('pointerenter', (event) => {
        if (!desktopHover.matches || event.pointerType !== 'mouse') return;
        openMenu(menu);
      });
      menu.addEventListener('pointerleave', (event) => {
        if (!desktopHover.matches || event.pointerType !== 'mouse') return;
        cancelHoverClose(menu);
        hoverCloseTimers.set(menu, window.setTimeout(() => {
          if (!menu.querySelector(':focus-visible')) closeMenu(menu);
        }, 200));
      });
      menu.querySelector('summary')?.addEventListener('click', (event) => {
        if (!desktopHover.matches || event.pointerType !== 'mouse') return;
        event.preventDefault();
        openMenu(menu);
      });
      menu.addEventListener('toggle', () => {
        if (menu.open) headerMenus.forEach((otherMenu) => {
          if (otherMenu !== menu) closeMenu(otherMenu);
        });
        if (menu.open) {
          menu.querySelector('.hz-new-arrivals-panel')?.scrollTo(0, 0);
          menu.querySelector('.hz-new-arrivals-panel__grid')?.scrollTo(0, 0);
        }
        syncMobileProductMenu();
      });
      menu.querySelectorAll('a[href^="#"]').forEach((link) => {
        link.addEventListener('click', () => closeMenu(menu));
      });
    });

    window.addEventListener('resize', syncMobileProductMenu, { passive: true });
    window.visualViewport?.addEventListener('resize', syncMobileProductMenu, { passive: true });
    mobileMenu.addEventListener('change', syncMobileProductMenu);

    document.addEventListener('click', (event) => {
      if (!mobileMenu.matches) return;
      const openProductMenu = Array.from(headerMenus).find((menu) =>
        menu.open && menu.querySelector('.hz-new-arrivals-panel')
      );
      if (!openProductMenu || openProductMenu.contains(event.target) || event.target.closest('[data-hz-header-menu]')) return;
      event.preventDefault();
      event.stopPropagation();
      closeMenu(openProductMenu);
    }, true);

    document.addEventListener('click', (event) => {
      headerMenus.forEach((menu) => {
        if (!menu.contains(event.target)) closeMenu(menu);
      });
    });
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      headerMenus.forEach((menu) => {
        if (!menu.open) return;
        closeMenu(menu);
        menu.querySelector('summary')?.focus();
      });
    });
  }

  document.querySelectorAll('[data-hz-home-reviews]').forEach((section) => {
    const rail = section.querySelector('.hz-home-reviews__rail');
    if (!rail) return;
    section.querySelectorAll('[data-hz-review-step]').forEach((button) => {
      button.addEventListener('click', () => {
        const pair = rail.querySelector('.hz-home-review-pair');
        const step = pair ? pair.getBoundingClientRect().width + 7 : 180;
        rail.scrollBy({ left: step * Number(button.dataset.hzReviewStep), behavior: reduceMotion ? 'auto' : 'smooth' });
      });
    });
    rail.addEventListener('keydown', (event) => {
      if (event.target !== rail || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault();
      section.querySelector(`[data-hz-review-step="${event.key === 'ArrowRight' ? 1 : -1}"]`).click();
    });
  });

  document.querySelectorAll('[data-hz-home-hero]').forEach((hero) => {
    const slides = Array.from(hero.querySelectorAll('[data-hz-hero-slide]'));
    const dots = Array.from(hero.querySelectorAll('[data-hz-hero-go]'));
    const autoplayButton = hero.querySelector('[data-hz-hero-autoplay]');
    if (slides.length < 2) return;

    let activeIndex = 0;
    let timer;
    let pointerStart = null;
    let suppressSwipeClick = false;
    let clickResetTimer;
    const stopTimer = () => {
      window.clearInterval(timer);
      timer = null;
      if (autoplayButton) {
        autoplayButton.setAttribute('aria-label', 'Play slideshow');
        autoplayButton.dataset.playing = 'false';
      }
    };
    const showSlide = (index) => {
      activeIndex = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === activeIndex;
        slide.hidden = !isActive;
        slide.inert = !isActive;
        slide.setAttribute('aria-hidden', String(!isActive));
        slide.querySelectorAll('a, button').forEach((item) => {
          item.tabIndex = isActive ? 0 : -1;
        });
      });
      dots.forEach((dot, dotIndex) => {
        const isActive = dotIndex === activeIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-pressed', String(isActive));
      });
    };

    hero.querySelectorAll('[data-hz-hero-step]').forEach((button) => {
      button.addEventListener('click', () => {
        stopTimer();
        showSlide(activeIndex + Number(button.dataset.hzHeroStep));
      });
    });
    dots.forEach((button) => {
      button.addEventListener('click', () => {
        stopTimer();
        showSlide(Number(button.dataset.hzHeroGo));
      });
    });

    hero.addEventListener('dragstart', (event) => event.preventDefault());
    hero.addEventListener('pointerdown', (event) => {
      if (event.button !== 0 || event.target.closest('button')) return;
      pointerStart = { id: event.pointerId, x: event.clientX, y: event.clientY };
    }, { passive: true });

    hero.addEventListener('pointerup', (event) => {
      const start = pointerStart;
      pointerStart = null;
      if (!start || start.id !== event.pointerId) return;

      const deltaX = event.clientX - start.x;
      const deltaY = event.clientY - start.y;
      if (Math.abs(deltaX) < 48 || Math.abs(deltaX) < Math.abs(deltaY) * 1.2) return;

      suppressSwipeClick = true;
      window.clearTimeout(clickResetTimer);
      clickResetTimer = window.setTimeout(() => { suppressSwipeClick = false; }, 500);
      stopTimer();
      showSlide(activeIndex + (deltaX < 0 ? 1 : -1));
    });

    hero.addEventListener('pointercancel', () => { pointerStart = null; });
    hero.addEventListener('click', (event) => {
      if (!suppressSwipeClick) return;
      event.preventDefault();
      event.stopPropagation();
      suppressSwipeClick = false;
      window.clearTimeout(clickResetTimer);
    }, true);

    const startTimer = () => {
      window.clearInterval(timer);
      timer = window.setInterval(() => showSlide(activeIndex + 1), 8000);
      if (autoplayButton) {
        autoplayButton.setAttribute('aria-label', 'Pause slideshow');
        autoplayButton.dataset.playing = 'true';
      }
    };
    autoplayButton?.addEventListener('click', () => {
      if (timer) stopTimer();
      else startTimer();
    });
    hero.addEventListener('focusin', (event) => {
      if (event.target !== autoplayButton) stopTimer();
    });
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stopTimer();
    });
    showSlide(0);
    stopTimer();
    if (!reduceMotion) startTimer();
  });

  document.querySelectorAll('[data-hz-home-rail]').forEach((shelf) => {
    const track = shelf.querySelector('[data-hz-rail-track]');
    if (!track) return;
    shelf.querySelectorAll('[data-hz-rail-step]').forEach((button) => {
      button.addEventListener('click', () => {
        const direction = Number(button.dataset.hzRailStep) || 1;
        track.scrollBy({ left: direction * Math.max(track.clientWidth * 0.82, 220), behavior: reduceMotion ? 'auto' : 'smooth' });
      });
    });
  });

  document.querySelectorAll('[data-hz-category-carousel]').forEach((carousel) => {
    const track = carousel.querySelector('[data-hz-category-track]');
    const previous = carousel.querySelector('[data-hz-category-step="-1"]');
    const next = carousel.querySelector('[data-hz-category-step="1"]');
    if (!track || !previous || !next) return;

    const updateControls = () => {
      previous.disabled = track.scrollLeft <= 1;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    };
    const scrollOneCard = (direction) => {
      const card = track.querySelector('.hz-home-category');
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      const distance = card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
      track.scrollBy({ left: direction * distance, behavior: reduceMotion ? 'auto' : 'smooth' });
    };

    previous.addEventListener('click', () => scrollOneCard(-1));
    next.addEventListener('click', () => scrollOneCard(1));
    track.addEventListener('scroll', updateControls, { passive: true });
    track.addEventListener('keydown', (event) => {
      if (event.target !== track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault();
      scrollOneCard(event.key === 'ArrowRight' ? 1 : -1);
    });
    window.addEventListener('resize', updateControls, { passive: true });
    updateControls();
  });

  document.querySelectorAll('[data-hz-product-carousel]').forEach((carousel) => {
    const track = carousel.querySelector('[data-hz-product-track]');
    const previous = carousel.querySelector('[data-hz-product-step="-1"]');
    const next = carousel.querySelector('[data-hz-product-step="1"]');
    if (!track || !previous || !next) return;

    const updateControls = () => {
      previous.disabled = track.scrollLeft <= 1;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    };
    const scrollProducts = (direction) => {
      const card = track.querySelector('.hz-home-product');
      if (!card) return;
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      const stride = card.getBoundingClientRect().width + gap;
      const visibleCards = Math.max(1, Math.round((track.clientWidth + gap) / stride));
      track.scrollBy({ left: direction * visibleCards * stride, behavior: reduceMotion ? 'auto' : 'smooth' });
    };
    previous.addEventListener('click', () => scrollProducts(-1));
    next.addEventListener('click', () => scrollProducts(1));
    track.addEventListener('scroll', updateControls, { passive: true });
    track.addEventListener('keydown', (event) => {
      if (event.target !== track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault();
      scrollProducts(event.key === 'ArrowRight' ? 1 : -1);
    });
    // Touch uses native scrolling. Mouse dragging starts only after a horizontal move,
    // keeping ordinary product links and quick-add buttons clickable.
    let pointer = null;
    let suppressClick = false;
    track.addEventListener('pointerdown', (event) => {
      suppressClick = false;
      if (event.pointerType !== 'mouse' || event.button !== 0 || event.target.closest('button, input, select, textarea')) return;
      pointer = { id: event.pointerId, x: event.clientX, y: event.clientY, left: track.scrollLeft, dragging: false };
    });
    track.addEventListener('pointermove', (event) => {
      if (!pointer || pointer.id !== event.pointerId) return;
      const distance = event.clientX - pointer.x;
      if (!pointer.dragging) {
        if (Math.abs(distance) < 8 || Math.abs(distance) < Math.abs(event.clientY - pointer.y)) return;
        pointer.dragging = true;
        track.classList.add('is-dragging');
        track.setPointerCapture(event.pointerId);
      }
      event.preventDefault();
      track.scrollLeft = pointer.left - distance;
    });
    const finishDrag = (event) => {
      if (!pointer || pointer.id !== event.pointerId) return;
      suppressClick = pointer.dragging;
      pointer = null;
      track.classList.remove('is-dragging');
      if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
      updateControls();
    };
    track.addEventListener('pointerup', finishDrag);
    track.addEventListener('pointercancel', finishDrag);
    track.addEventListener('dragstart', (event) => event.preventDefault());
    track.addEventListener('click', (event) => {
      if (!suppressClick) return;
      event.preventDefault();
      event.stopPropagation();
      suppressClick = false;
    }, true);
    const resizeObserver = new ResizeObserver(updateControls);
    resizeObserver.observe(track);
    updateControls();
  });

  document.querySelectorAll('.hz-home-shelf').forEach((shelf) => {
    const tabs = Array.from(shelf.querySelectorAll('[data-hz-home-tab]'));
    const panels = Array.from(shelf.querySelectorAll('[data-hz-home-panel]'));
    if (tabs.length !== panels.length || tabs.length < 2) return;

    const activateTab = (index, focus = false) => {
      const activeIndex = (index + tabs.length) % tabs.length;
      tabs.forEach((tab, tabIndex) => {
        const isActive = tabIndex === activeIndex;
        tab.setAttribute('aria-selected', String(isActive));
        tab.tabIndex = isActive ? 0 : -1;
        if (isActive && focus) tab.focus();
      });
      panels.forEach((panel, panelIndex) => {
        const isActive = panelIndex === activeIndex;
        panel.hidden = !isActive;
        panel.inert = !isActive;
        panel.setAttribute('aria-hidden', String(!isActive));
      });
    };

    tabs.forEach((tab, tabIndex) => {
      tab.addEventListener('click', () => activateTab(tabIndex));
      tab.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft' || event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          const nextIndex = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : tabIndex + (event.key === 'ArrowRight' ? 1 : -1);
          activateTab(nextIndex, true);
        }
      });
    });
  });
})();
